<template>
	<div class="addNewCourse">
		<el-dialog title="修改名称" :visible.sync="dialogVisible" width="500px">
			<div>
				<el-form ref="form" :model="form" :rules="rules" label-position="top">
					<el-form-item label="名称" prop="name">
						<el-input
							v-model="form.name"
							placeholder="请输入新的名称"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit('form')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	emits: ["success"],
	props: {
	
	},
	data() {
		// let validateNo = (rule, value, callback) => {
		// 	if (value.trim().length == 0) {
		// 		callback(new Error("请输入课堂编号"));
		// 	}else if(this.courseList.findIndex(i=>i.value==value.trim())!=-1){
		// 		callback(new Error("该课堂编号已存在"));
		// 	} else {
		// 		callback();
		// 	}
		// };
		// let validateName = (rule, value, callback) => {
		// 	if (value.trim().length == 0) {
		// 		callback(new Error("请输入课堂名称"));
		// 	} else {
		// 		callback();
		// 	}
		// };
		return {
			dialogVisible: false,
			form: {
				name: "",
			},
			rules: {
				name: [
					{ required:true,trigger: "change",message:"请输入新的名称"},
					{min:1,max:20,trigger: "change",message:"长度需在1-20个字符之间"}
			],
			},
		};
	},
	methods: {
		open(name='新的名称') {
			this.form.name = name;
			this.dialogVisible = true;
		},
		close(){
			this.dialogVisible = false;
		},
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$emit("success", this.form.name);
				} else {
					return false;
				}
			});
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/editNameDialog.vue